const initialState = window.__MODEL__;
const scriptsTopology = window.__SCRIPTS_TOPOLOGY__;
module.exports = {
  scriptsTopology,
  ...initialState,
};
